import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

import { AbstractModel } from '@uzurv/core';
import { Driver } from './driver';

@inheritSerialization(AbstractModel)
export class TransitProgramDriver extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserializeAs(Driver)
  driver: Driver;

  @autoserialize
  active: boolean;

  @autoserialize
  preferred: boolean;

  constructor() {
    super();
    this.active = true;
  }
}
